import { useMutation } from "@tanstack/react-query";
import { api } from "shared/api";

const fetchStandardProductOrder = async (orderId: string) => {
  const res = await api().gersGetStandardProductOrder(orderId);
  return res.data;
};

export const useStandardProductOrder = () =>
  useMutation(fetchStandardProductOrder);
